import { createAction, props } from '@ngrx/store';
import { IsUserBlockedRequest, IsUserBlockedResponse, IUserBlockedUpdateRequest, IUserBlockedUpdateResponse } from '../models/block.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

//Check if user is blocked
export const checkIfUserBlockedRequest = createAction('[Block] Check Blocked request', props<{ request: string }>());

export const checkIfUserBlockedSuccess = createAction('[Block] Check Blocked Success', props<{ response: IsUserBlockedResponse }>());

export const checkIfUserBlockedFailure = createAction('[Block] Check Blocked Failure', props<{ error: IGenericError<ErrorResponse> }>());

//Update if user is blocked
export const updateUserBlockedRequest = createAction('[Block] Load Blocked request', props<{ request: IUserBlockedUpdateRequest }>());

export const updateUserBlockedSuccess = createAction('[Block] Load Blocked Success', props<{ response: IUserBlockedUpdateResponse }>());

export const updateUserBlockedFailure = createAction('[Block] Load Blocked Failure', props<{ error: IGenericError<ErrorResponse> }>());

//Update if user is unblocked
export const updateUserUnBlockedRequest = createAction('[Block] Load unBlocked request', props<{ request: IUserBlockedUpdateRequest }>());

export const updateUserUnBlockedSuccess = createAction('[Block] Load unBlocked Success', props<{ response: IUserBlockedUpdateResponse }>());

export const updateUserUnBlockedFailure = createAction('[Block] Load unBlocked Failure', props<{ error: IGenericError<ErrorResponse> }>());

export const clearStatusRequest = createAction('[Block] Clear status request');
